export function isInDanger(stage, position, zone) {
    let time = zone || stage.zone
    time += 1
    time *= 2
    if(position.x < (time - (position.y * 2))
    || position.x < (time - (((stage.world.height - 1) - position.y) * 2)  )
    || position.x > (stage.world.width - 1) - (time - (position.y * 2))
    || position.x > (stage.world.width - 1) - (time - (((stage.world.height - 1) - position.y) * 2) )     ) {
        return true
    }
    return false

    // return position.x < time
    //     || position.y < time
    //     || position.x >= stage.world.width - time
    //     || position.y >= stage.world.height - time
}
